import type {
  GraphicPromo,
  GraphicPromoById,
  GraphicPromoState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/graphicPromo';

export const getAll = (state: GraphicPromoState): GraphicPromoById => state.byId;
export const get = (state: GraphicPromoState, id: string): GraphicPromo => state.byId[id];
